// src/pages/error/NotFoundPage.jsx
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Button from "../../components/shared/Button";

import {
  FaArrowLeft,
  FaExclamationCircle,
} from "react-icons/fa";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const isAR = i18n.resolvedLanguage?.startsWith("ar");

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 px-4">
      <div className="w-full max-w-2xl text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-primary text-[150px] leading-none font-bold md:text-[200px]">
            404
          </h1>

          <div className="from-primary to-tertiary mx-auto h-1 w-32 bg-gradient-to-r" />
        </div>

        {/* Message */}
        <div className="mb-8 space-y-4">
          <div className="flex justify-center">
            <div className="bg-primary/10 text-primary flex h-20 w-20 items-center justify-center rounded-full">
              <FaExclamationCircle className="text-4xl" />
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-slate-800 md:text-3xl">
            {t("notFound.title")}
          </h2>

          <p className="mx-auto max-w-md text-slate-600">
            {t("notFound.description")}
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button
            text={t("notFound.goBack")}
            onClick={() => navigate(-1)}
            className="w-full gap-2 sm:w-auto"
          />

        </div>
      </div>
    </div>
  );
}